export const text = {
  title: 'Sowing calendar',
  description: 'What to sow, how many seeds, and when — for the selected garden.',
  gardenSelectLabel: 'Garden',
  selectGardenPrompt: 'Select a garden to view the sowing calendar.',
  noPlantsInGarden: 'No plants in this garden yet.',
  addPlantsFirst: 'Add plants in the garden planner first.',
  viewMonth: 'Month',
  viewWeek: 'Week',
  viewAgenda: 'Agenda',
  agendaTitle: 'Sowing agenda',
  sectionDueNow: 'Sow this week',
  sectionUpcoming: 'Coming up',
  sectionSown: 'Sown & growing',
  sectionOutOfSeason: 'Out of season',
  legendOutdoor: 'Sow outdoors',
  legendIndoor: 'Start indoors',
  legendSown: 'Sown & growing',
  legendOutOfSeason: 'Out of season',
  laterFooter: 'Later',
  notInSeasonFooter: 'Not in season',
  markSown: 'Mark sown',
  statusSowOutdoors: 'Sow outdoors',
  statusStartIndoors: 'Start indoors',
  statusGrowing: 'Sown',
  statusOutOfSeason: 'Out of season',
  monthTagSown: (plantName: string) => `✓ ${plantName}`,
  slotsFilled: 'slots filled',
  prevPeriod: 'Previous',
  nextPeriod: 'Next',
  dueNow: 'Due now',
  morePlants: (count: number) => `+${count} more`,
  emptySelectedDay: 'Nothing planned on this day.',
  selectedDayTitle: (dateLabel: string) => `Planned · ${dateLabel}`,
  seedsStrong: (seeds: number) => `${seeds} seeds`,
  slotsBuffer: (slots: number, buffer: number) => `${slots} slots + ${buffer} buffer`,
  seedsMeta: (seeds: number, slots: number, buffer: number) =>
    `${seeds} seeds (${slots} slots + ${buffer} buffer)`,
  sownSlots: (slots: number) => `${slots} / ${slots}`,
  weekSummary: (actions: number, seeds: number) =>
    `${actions} sow action${actions === 1 ? '' : 's'} · ${seeds} seeds this week`,
  outdoorSubtext: (windowLabel: string) => (windowLabel ? `Outdoor · ${windowLabel}` : 'Outdoor'),
  indoorSubtext: (windowLabel: string) => (windowLabel ? `Indoor · ${windowLabel}` : 'Indoor'),
  sownSubtext: 'Already sown',
  outOfSeasonSubtext: (windowLabel: string) => (windowLabel ? windowLabel : 'No sow timing set'),
  monthTag: (plantName: string, method: 'outdoor' | 'indoor') =>
    `${plantName} · ${method === 'outdoor' ? 'outdoor' : 'indoor'}`,
  footerPlantOpens: (plantName: string, windowLabel: string) =>
    windowLabel ? `${plantName} · ${windowLabel}` : plantName,
  footerPlantSown: (plantName: string) => `${plantName} · sown, growing`,
  sectionWithDetail: (title: string, detail: string) => `${title} · ${detail}`,
  timeBucketDueNow: 'Due now',
  timeBucketLater: 'Later',
  timeBucketSown: 'Sown',
  timeBucketStarting: (when: string) => `Starting ${when}`,
};
